export type BlipChatProp = {
    appKey: string
    accessibilityLabel: string
    customCommonUrl: string
    userIdentity: string
}

const HTML = `<!DOCTYPE html>
  <html lang="en">
        <head>  
            <meta charset="UTF-8">  
            <meta name="viewport" content="width=device-width, initial-scale=1"> 
            <meta http-equiv="X-UA-Compatible" content="ie=edge">  

            <meta name="referrer" content="no-referrer" />
            <meta name="referrer" content="unsafe-url" />
            <meta name="referrer" content="origin" />
            <meta name="referrer" content="no-referrer-when-downgrade" />
            <meta name="referrer" content="origin-when-cross-origin" />

            <script type="text/javascript" src="https://unpkg.com/blip-chat-widget"></script>  
            <style>html, body { width: 100%; height: 100%; margin: 0; }</style>
        </head>
        
        <body id="sdkTarget">
            <script>
                (function () {
                    window.onload = function () {
                        var blipClient = new BlipChat()
                            .withAppKey('%appKey%')
                            .withTarget('sdkTarget')
                            .withAuth({
                                "authType": BlipChat.DEV_AUTH,
                                "userIdentity": "%userIdentity%",
                                "userPassword": "%userPassword%"
                            })
                            .withAccount(null)
                            .withConnectionData({})
                            .withCustomCommonUrl('%customCommonUrl%')
                            .withEventHandler(BlipChat.LOAD_EVENT,function () {
                                blipClient.sendMessage({
                                "type": "text/plain",    
                                "content": "Start",    
                                "metadata":{    
                                "#blip.hiddenMessage": true    
                                }    
                            });
                        });
                        blipClient.build();
                    }        
                })();
            </script>
        </body>
  </html>
  `;

const BlipChat = ({ appKey, accessibilityLabel, customCommonUrl, userIdentity }: BlipChatProp) => {
    const content = HTML
        .replace("%appKey%", appKey)
        .replace("%customCommonUrl%", customCommonUrl)
        .replace("%userIdentity%", userIdentity)
        .replace("%userPassword%", userIdentity);

    return (
        <div
            style={{
                width: '100%',
                height: '100%'
            }}
            data-testid={`${accessibilityLabel}_blipChat`}
        >
            <iframe
                title="Blip Chat"
                srcDoc={content}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none'
                }}
                data-testid={`${accessibilityLabel}_blipChatFrame`}
            />
        </div>
    );
};

export default BlipChat;